import ImageMapper from 'react-img-mapper';
import CockpitImg from './static/cockpit.jpg'

const Mapper = props => {
  const url = CockpitImg;

  const name = 'my-map';

  return (

    <ImageMapper 
      src={url} 

      name={name}

      areas={props.areas}
      parentWidth={0.7*window.innerWidth}
      responsive={true}
      // onMouseDown={onMouseDown}
      onChange={props.onChange}
      onMouseMove={props.onMouseMove}
      disabled={props.isDisabled}
      

    />

  )

}


export default Mapper;